export default {
  dataSearch: {},
  dataSearchOther: {},
  router: null
}
